/* eslint react/destructuring-assignment: off */
// TODO: The logo flashes in, which reflows all the header links, and it looks terrible.
import React from 'react';
import styled from 'styled-components';
import memoizeOne from 'memoize-one';
import PropTypes from 'prop-types';
import { doesElementFullyContainChild } from 'dom-utils';
import { SPACING_LARGE } from 'style/constants';
import KeyedListMapper from 'components/core/KeyedListMapper';
import { NAVIGATION_ID } from 'global-ids';
import NavBurger from './NavBurger';
import HeaderItem from './HeaderItem';

const SIZE_CHECK_INTERVAL_MS = 500;

export const LinkSectionWrapper = styled.div`
  align-items: stretch;
  display: flex;
  flex-flow: row nowrap;
  flex-grow: 1;
  position: relative;
`;
export const Links = styled.nav`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  flex-grow: 1;
  flex-shrink: 1;
  margin-left: ${SPACING_LARGE};
`;

export const HeaderLinksInner = styled.div`
  position: absolute;
  left: ${SPACING_LARGE};
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  & > * {
    margin: 0 20px;
  }
`;

const StyledBurger = styled(NavBurger)`
  align-self: center;
`;

export default class HeaderLinks extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    currentRoute: PropTypes.string.isRequired,
    navDoc: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    siteDomain: PropTypes.string.isRequired,
    trackHeader: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
  };

  childRefs = new Map();

  parentRef = null;

  sizeCheckInterval = null;

  computeOverflowItems = memoizeOne((list, numVisible) => {
    if (numVisible >= (list?.length || 0)) {
      return [];
    }
    return list.slice(numVisible);
  });

  state = {
    visibleCount: this.props.navDoc.items?.length || 0,
  };

  componentDidMount() {
    setTimeout(this.sizeCheck, 0); // Prevent menu flashing in on load. Yes, it's gross...
    this.sizeCheckInterval = setInterval(
      this.sizeCheck,
      SIZE_CHECK_INTERVAL_MS,
    );
  }

  componentWillUnmount() {
    clearInterval(this.sizeCheckInterval);
    this.sizeCheckInterval = null;
  }

  onTrackNav = (kind, title, url, image) => {
    const { trackHeader } = this.props;

    const doc = {
      displayKind: image ? 'image' : 'text',
      kind: 'navigation',
      title: title || null,
    };
    const extra = { ...(image && { image }), kind, url };

    trackHeader(doc, extra);
  };

  get overflowItems() {
    return this.computeOverflowItems(
      this.props.navDoc.items,
      this.state.visibleCount,
    );
  }

  setChildRef = (index, ref) => {
    const { childRefs } = this;
    if (ref) {
      childRefs.set(index, ref);
    } else {
      childRefs.delete(index);
    }
  };

  setParentRef = (ref) => {
    this.parentRef = ref;
  };

  sizeCheck = () => {
    const { parentRef } = this;
    if (!parentRef) {
      return;
    }
    let visibleCount = this.props.navDoc.items?.length || 0; // Start at max and iterate down
    for (; visibleCount > 0; visibleCount--) {
      const index = visibleCount - 1;
      const childRef = this.childRefs.get(index);
      const visible =
        childRef && doesElementFullyContainChild(parentRef, childRef);
      if (visible) {
        break;
      }
    }
    this.setState((state) => {
      if (state.visibleCount === visibleCount) {
        return null;
      }
      return { visibleCount };
    });
  };

  renderHeaderLink(data, props = {}) {
    const { siteDomain } = this.props;
    const { link, text, image, hasMenu, children } = data;
    return (
      <HeaderItem
        currentRoute={this.props.currentRoute}
        hasMenu={hasMenu}
        image={image}
        link={link}
        menuItems={children}
        onTrackNav={this.onTrackNav}
        siteDomain={siteDomain}
        text={text}
        {...props}
      />
    );
  }

  render() {
    const { navDoc } = this.props;
    if (navDoc.state === 'off') {
      return null;
    }
    const { visibleCount } = this.state;
    const showMore = Boolean(this.overflowItems.length);
    return (
      <LinkSectionWrapper>
        <Links ref={this.setParentRef} id={NAVIGATION_ID}>
          <HeaderLinksInner>
            <KeyedListMapper keyField="arrayId" list={navDoc.items}>
              {(key, data, index) => this.renderHeaderLink(data, {
                domRef: ref => this.setChildRef(index, ref),
                index,
                key,
                visible: index < visibleCount,
              })}
            </KeyedListMapper>
          </HeaderLinksInner>
        </Links>
        <StyledBurger show={showMore}>
          <KeyedListMapper keyField="arrayId" list={this.overflowItems}>
            {(key, data, index) => this.renderHeaderLink(data, {
              fullWidth: true,
              index,
              key,
              overflow: true,
              visible: true,
            })}
          </KeyedListMapper>
        </StyledBurger>
      </LinkSectionWrapper>
    );
  }
}
